import axios from 'axios';
import { axiosETAGCache } from 'axios-etag-cache';

// Apply the axios ETAG interceptor
const axiosWithETAGCache = axiosETAGCache(axios);
const api = {
  async getDefaultOutboundRules() {
    const queryParams = {};

    const response = await axiosWithETAGCache.get(`/default_outbound_rules`, {
      params: queryParams,
    });

    return response.data;
  },
  async saveDefaultOutboundRules(defaultOutboundRules) {
    const response = await axios.put(
      `/default_outbound_rules`,
      defaultOutboundRules
    );
    return response.data;
  },
};

export default api;
